enum UserRequestStatus {
    pending,
    cancelled,
    approved,
}

export default UserRequestStatus;
